export enum VesselVisitDocumentStatusCodes {
    Acknowledged = 'ACK',
    Approved = 'APP',
    Canceled = 'CAN',
    InProgress = 'INP',
    Rejected = 'REJ',
    WaitingApproval = 'WAP',
    WaitingAgentApproval = 'WFA',
    WaitingDispatchApproval = 'WFD'
}